import { useEffect } from "react";
import { Button } from "./button";

type Props = {
  error: Error;
  reset?: () => void;
  context: string;
};

export function ErrorDisplay({ error, reset, context }: Props) {
  useEffect(() => {
    console.error(`${context} error:`, error);
  }, [error, context]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h2 className="font-display text-2xl text-text-primary">
        Something Went Wrong
      </h2>
      <p className="text-text-muted">
        An unexpected error occurred. Please try again.
      </p>
      {reset && <Button onClick={reset}>Try Again</Button>}
    </div>
  );
}
